import './DevSection.css';

const codeLines = [
  [['kw', 'const'], ['id', ' settlor = '], ['fn', 'require'], ['id', '('], ['str', "'@settlor/sdk'"], ['id', ')(process.env.SETTLOR_KEY);']],
  [],
  [['kw', 'const'], ['id', ' payout = '], ['kw', 'await'], ['id', ' settlor.payouts.'], ['fn', 'create'], ['id', '({']],
  [['key', '  amount'], ['id', ': 25000,']],
  [['key', '  rail'], ['id', ': '], ['str', "'IMPS'"], ['id', ',']],
  [['key', '  beneficiary'], ['id', ': {']],
  [['key', '    name'], ['id', ': '], ['str', "'Aarav Mehta'"], ['id', ',']],
  [['key', '    account'], ['id', ': '], ['str', "'50100XXXXXX2840'"], ['id', ',']],
  [['key', '    ifsc'], ['id', ': '], ['str', "'HDFC0001234'"]],
  [['id', '  },']],
  [['key', '  idempotencyKey'], ['id', ': '], ['str', "'po_2026_0001'"]],
  [['id', '});']],
  [],
  [['cm', "// payout.status -> 'processing'"]],
];

export default function DevSection() {
  return (
    <section className="dev">
      <div
        className="dev__bg"
        style={{ backgroundImage: 'url(/dev-bg.png)' }}
      />
      <div className="dev__container">
        <div className="dev__left">
          <p className="dev__eyebrow">For developers</p>
          <h2 className="dev__heading">A payouts API built for <span className="dev__heading--accent">developers</span></h2>
          <ul className="dev__list">
            <li className="dev__list-item">
              <span className="dev__check">✓</span>
              <span><span className="dev__item-bold">Dedicated SDKs </span><span className="dev__item-dim">for Node, Python, Go and more, so you ship without wrestling raw HTTP.</span></span>
            </li>
            <li className="dev__list-item">
              <span className="dev__check">✓</span>
              <span><span className="dev__item-dim">A </span><span className="dev__item-bold">full sandbox </span><span className="dev__item-dim">with test API keys to try every endpoint before you go live.</span></span>
            </li>
            <li className="dev__list-item">
              <span className="dev__check">✓</span>
              <span><span className="dev__item-bold">Signed webhooks that </span><span className="dev__item-dim">push real-time transfer status, from processing to settled.</span></span>
            </li>
          </ul>
          <a href="#docs" className="dev__cta">
            View API documentation
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M3.125 7.5H11.875" stroke="#06122E" strokeWidth="1.5625" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M7.5 3.125L11.875 7.5L7.5 11.875" stroke="#06122E" strokeWidth="1.5625" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </div>
        <div className="dev__code-wrap">
          <div className="dev__tabs">
            <button className="dev__tab dev__tab--active">Node.js</button>
            <button className="dev__tab">Python</button>
            <button className="dev__tab">cURL</button>
          </div>
          <div className="dev__code">
            <div className="dev__code-body">
              {codeLines.map((line, i) => (
                <div key={i} className="dev__line">
                  <span className="dev__linenum"></span>
                  <span className="dev__line-code">
                    {line.map(([type, text], j) => (
                      <span key={j} className={`dev__token--${type}`}>{text}</span>
                    ))}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
